import { createSlice } from '@reduxjs/toolkit'

const initialState: { deciderSelectFields: Record<string, string[]>; loading: boolean; error: string | null } = {
  deciderSelectFields: {},
  loading: false,
  error: null,
}

const deciderFieldsSlice = createSlice({
  name: 'deciderFields',
  initialState,
  reducers: {
    setDeciderSelectFields: (state, action) => {
      state.deciderSelectFields = action.payload
    },
  },
})

export const { setDeciderSelectFields } = deciderFieldsSlice.actions

export default deciderFieldsSlice.reducer
